import { inject, Injectable } from '@angular/core';
import { LocalStorage } from './local-storage.service';
import { DelegationStatus } from '../constants/role.constants';

export interface DelegatedRoleItem {
  roleId?: string;
  id?: string;
  name?: string;
  status?: DelegationStatus | string;
}

@Injectable({
  providedIn: 'root'
})
export class RoleAccessService {
  private readonly localStorageService = inject(LocalStorage);

  isSubAdmin(): boolean {
    return !!this.localStorageService.getDataByKey('subAdminDetails');
  }

  getSubAdminDetails<T = any>(): T | null {
    return this.localStorageService.getDataByKey('subAdminDetails');
  }

  getActiveRoleIds(): string[] {
    const details = this.getSubAdminDetails<any>();
    if (!details) return [];

    const rawRoles =
      details.delegatedRoles ??
      details.roles ??
      details.permissions ??
      details.delegations ??
      [];

    if (!Array.isArray(rawRoles)) return [];

    const activeRoles: string[] = [];

    rawRoles.forEach((role: string | DelegatedRoleItem) => {
      if (typeof role === 'string') {
        activeRoles.push(role);
        return;
      }

      const roleId = role.roleId || role.id || role.name;
      if (!roleId) return;

      const status = (role.status || 'active').toString().toLowerCase();
      if (status === 'revoked' || status === 'inactive') return;
      if (status === 'pending') return;

      activeRoles.push(roleId);
    });

    return Array.from(new Set(activeRoles));
  }

  hasRole(roleId: string): boolean {
    return this.getActiveRoleIds().includes(roleId);
  }
}
